module.exports = __webpack_public_path__ + "img/404.8b1979b6.jpg";